exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Roboto);", ""]);

// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\nbody {\n  font-family: 'Roboto', sans-serif;\n  margin: 0 auto; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/sgarciadarosa/Documents/TestApps/angular-notification/~/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/sgarciadarosa/Documents/TestApps/angular-notification/~/postcss-loader?{"ident":"postcss"}!C:/Users/sgarciadarosa/Documents/TestApps/angular-notification/~/sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!C:/Users/sgarciadarosa/Documents/TestApps/angular-notification/src/styles.sass
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../sass-loader/lib/loader.js?{"sourceMap":false,"precision":8,"includePaths":[]}!../../../../../src/styles.sass
// module chunks = 2